import React from "react";
import { Fab, Tooltip, withStyles } from "@material-ui/core";
import { primaryColor, primaryColorDark, red } from "../../assets/jss/appHealth.style";

const styles = () => ({
    optionButton: {
        display: 'flex',
    },
    labelGreen: {
        borderRadius: '1000px',
        position: 'relative',
        right: '-28px',
        display: 'flex',
        alignItems: 'center',
        paddingRight: '30px',
        paddingLeft: '12px',
        boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.16)',
        fontWeight: 600,
        cursor: 'pointer',
        background: '#CFE8E7',
        '& span': {
            whiteSpace: 'nowrap',
            color: '#0F8784',
            fontSize: "12px"
        }
    },
    labelRed: {
        borderRadius: '1000px',
        position: 'relative',
        right: '-25px',
        display: 'flex',
        alignItems: 'center',
        paddingRight: '30px',
        paddingLeft: '12px',
        boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.16)',
        fontWeight: 600,
        background: '#FFEDED',
        cursor: 'pointer',
        '& span': {
            color: '#FB7676',
            fontSize: "12px"
        }
    },
    labelPurple: {
        borderRadius: '1000px',
        position: 'relative',
        right: '-25px',
        display: 'flex',
        alignItems: 'center',
        paddingRight: '30px',
        paddingLeft: '12px',
        boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.16)',
        fontWeight: 600,
        background: 'rgba(150, 38, 172, 0.1)',
        cursor: 'pointer',
        '& span': {
            color: 'rgba(150, 38, 172, 1)',
            fontSize: "12px"
        }
    },
    buttonGreen: {
        minWidth: "40px",
        maxWidth: "40px",
        height: "40px",
        minHeight: "1px",
        background: primaryColor,
        "&:hover": {
            background: primaryColorDark,
        },
    },
    buttonRed: {
        width: "40px",
        height: "40px",
        minHeight: "1px",
        background: red,
        "&:hover": {
            background: '#f92e2e',
        },
    },
    buttonPurple: {
        width: "40px",
        height: "40px",
        minHeight: "1px",
        background: 'rgba(150, 38, 172, 1)',
        "&:hover": {
            background: 'rgba(150, 38, 172, 0.8)',
        },
    },
        imageGif: {
        width: "100%",
        height: "100%",
        borderRadius: "50%",
        objectFit: "contain",
        display: "block",
        animation: "blink 10s ease-in-out infinite",
        transformOrigin: "center center",
        willChange: "transform",
    },

    "@keyframes blink": {
        "0%": { transform: "scale(1)", opacity: 1 },

        "1%": { transform: "scale(1.08)", opacity: 1 },
        "2%": { transform: "scale(1.15)", opacity: 1 },
        "3%": { transform: "scale(1.08)", opacity: 1 },

        "4%": { transform: "scale(1)", opacity: 1 },
        "100%": { transform: "scale(1)", opacity: 1 },
    },

})

const LabelButton = (props) => {
    const { title, classes, icon, onClick, redColor, purpleColor, hiddenLabel, disabled, transition, hidden, id } = props;
    const labelStyle = redColor ? classes.labelRed : purpleColor ? classes.labelPurple : classes.labelGreen;
    const buttonStyle = redColor ? classes.buttonRed : purpleColor ? classes.buttonPurple : classes.buttonGreen;


    return (
        <>
            { !hidden &&<div className={classes.optionButton}>
                { !hiddenLabel && <div id={id} className={labelStyle} onClick={onClick}>
                    <span>{title}</span>
                </div>}
                <Fab id={id} className={buttonStyle} onClick={onClick} disabled={disabled}>
                    {
                        transition ? (

                            <div className={classes.optionButton} style={{ cursor: "pointer" }}>
                                <img src={icon} alt={title} className={classes.imageGif} />
                            </div>

                        ) : (

                            <Tooltip
                                title={title}
                                placement="left"
                            >
                                {
                                    typeof icon === 'string' ?
                                        <img
                                            className={classes.documentoIcon}
                                            src={icon}
                                            alt={title}
                                        />
                                        :
                                        icon
                                }
                            </Tooltip>
                        )}
                </Fab>
            </div>}

        </>
    )
}

export default withStyles(styles)(LabelButton);